import service from '@api/vipConfig'


// 查询邀工币变动  type:类型 1-获取，2-使用
export const coinRecord = (data) => {
  return service.request({
    url: `/coin/record`,
    method: 'post',
    data: data
  })
}

// 获取邀工币/积分数量
export const getNo = () => {
  return service.request({
    url: `/score/getNo`,
    method: 'post'
  })
}
